import { render, staticRenderFns } from "./ScrollingCardsView.vue?vue&type=template&id=626816f2&scoped=true&"
import script from "./ScrollingCardsView.vue?vue&type=script&lang=js&"
export * from "./ScrollingCardsView.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingCardsView.vue?vue&type=style&index=0&id=626816f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626816f2",
  null
  
)

export default component.exports